import React, { useState } from 'react';
import { SignUpLink } from './SignUp';
import * as ROUTES from '../constants/routes';
import { useAuthentication } from '../components/Session';
import { useHistory, Link } from 'react-router-dom';
import { PasswordForgetLink } from './PasswordForget';
import {
  TextField,
  makeStyles,
  Button,
  Container,
  CssBaseline,
  Avatar,
  Typography,
  Checkbox,
  Box,
  Grid,
  FormControlLabel
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import LoadingScreen from './Loading';

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

const Copyright = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {'Copyright © '}
    <Link to="https://autote.app" color="inherit">
      Autote
    </Link>{' '}
    {new Date().getFullYear()}
    {'.'}
  </Typography>
);

const SignInPage = props => {
  const classes = useStyles();
  console.debug('signinpage got location props', props.location);
  const { referrer } = props.location.state || {
    referrer: { pathname: ROUTES.TRANSCRIPTION_LIST }
  };
  console.debug('working with ', referrer);
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <SignInForm redirect={referrer} />
        <Grid container>
          <PasswordForgetLink />
          <SignUpLink />
        </Grid>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

const SignInForm = ({ redirect }) => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const auth = useAuthentication();
  const history = useHistory();

  const handleSubmit = e => {
    setLoading(true);
    auth
      .signIn(email, password)
      .then(() => {
        console.log('signin complete');
        setEmail('');
        setPassword('');
        setError(null);
        console.log('forwarding user now to', redirect);
        setLoading(false);
        history.push(redirect);
      })
      .catch(err => {
        setError(err);
        setEmail('');
        setPassword('');
        setLoading(false);
      });
    e.preventDefault();
  };

  const isInvalid = password === '' || email === '';

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      {loading && <LoadingScreen />}
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email Address"
        autoComplete="email"
        autoFocus
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        name="email"
      />
      <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        label="Password"
        type="password"
        name="password"
        id="password"
        autoComplete="current-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      {error && <p className={classes.error}>{error.message}</p>}
      <FormControlLabel
        control={<Checkbox value="remember" color="primary" />}
        label="Remember me"
      />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        disabled={isInvalid}
        type="submit"
        className={classes.submit}
      >
        Sign In
      </Button>
    </form>
  );
};

const SignInLink = () => (
  <Grid item>
    <Link to={ROUTES.SIGN_IN}>{'Already have an account? Sign in'}</Link>
  </Grid>
);

export default SignInPage;
export { SignInForm, SignInLink };
